module.exports = __webpack_public_path__ + "static/media/Black Panther 3.530cfaf9.jpg";